var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart"},[_c('vs-loader',{attrs:{"visible":!!_vm.itemCoverageTotals.isLoading}}),(_vm.chartData)?[_c('item-coverage-chart',{attrs:{"chartData":_vm.chartData,"options":_vm.chartOptions,"height":_vm.height,"width":_vm.width,"styles":{
        maxWidth: '725px',
        margin: 'auto'
      }}},[_c('div',[_c('h3',[_vm._v(_vm._s(_vm.total))]),_c('span',[_vm._v("Items test123")])])])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }